import React from 'react';
import POIDetails from './POIDetails';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 12px;
  overflow: hidden;
`;

const POIPageContent = ({ poi, onFavoriteRemoved, onShowToast }) => {
  return (
    <Container>
      <POIDetails 
        poi={poi}
        isModal={false}
        onFavoriteRemoved={onFavoriteRemoved}
        onShowToast={onShowToast}
      />
    </Container>
  );
};

export default POIPageContent; 